import axios from "axios";

export const axiosClientHub = axios.create({
    baseURL: process.env.REACT_APP_HUB_URL,
    responseType: 'json',
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('AuthToken')}`
    }
})
